import React from 'react';

interface DashboardHeaderProps {
  title: string;
  subtitle: string;
  welcomeMessage: string;
  showEncouragement?: boolean;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  title,
  subtitle,
  welcomeMessage,
  showEncouragement = false,
}) => {
  return (
    <div className="bg-gradient-to-r from-card via-secondary/50 to-card backdrop-blur-sm rounded-xl p-4 sm:p-6 border border-primary/20 shadow-lg">
      <div className="mb-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent">
            {title}
          </h1>
          <p className="text-sm sm:text-base text-primary/80 font-medium">{subtitle}</p>
        </div>
      </div>
      <p className="text-sm sm:text-base text-muted-foreground">{welcomeMessage}</p>
      {showEncouragement && (
        <div className="mt-3 px-4 py-2 bg-primary/10 border border-primary/30 rounded-lg">
          <div className="text-sm text-primary font-medium flex items-center gap-2">
            💪 You're doing great! Keep up the momentum!
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardHeader;
